(function($, root) {
  "use strict";
  // https://codepen.io/ccrch/pen/GgPLVW

  $.onPlayerReady = function(e) {

    // console.log('youtube player is ready');
    // if (window.rdo.data.selected.content.background_video) {
    if (window.rdo.video.playerDefaults.autoplay) {

      window.rdo.video.tv.playVideo();

    }

    // // window.rdo.video.tv.loadVideoById(window.rdo.data.selected.content.background_video);
    if (window.rdo.video.mute) {
      window.rdo.video.tv.mute();
    }
    // }
  }

  $.onPlayerStateChange = function(e, onDone, onPlay, onPause, onUnstarted) {

    if (e.data === 1) {
      //playing
      // console.log('playing');

      if (onPlay) {
        // if (window.rdo.isMobile) {
        //   $('intro .tv iframe').show();
        // }
        //
        onPlay();

      }

      window.rdo.video.numPlayAttempts++;

    } else if (e.data === 2) {
      //paused
      // console.log('paused');

      if (onPause) {
        onPause();
      }

      // if (currVid === vid.length - 1) {
      //   currVid = 0;
      // } else {
      //   currVid++;
      // }
      // if (window.rdo.data.selected.content.background_video) {
      //   // window.rdo.video.tv.playVideo();
      //   // // window.rdo.video.tv.loadVideoById(window.rdo.data.selected.content.background_video);
      //   // window.rdo.video.tv.mute();
      // }
      // window.rdo.video.tv.loadVideoById(vid[currVid]);
      // window.rdo.video.tv.seekTo(vid[currVid].startSeconds);
    } else if (e.data === 0) {
      //ended
      // console.log('ended');
      if (onDone) {
        onDone();
      }

    } else if (e.data === 3) {
      //buffering
      // console.log('buffering');

    } else if (e.data === -1) {
      //unstarted
      // console.log('unstarted');
      if (onUnstarted) {
        onUnstarted();
      }
    } else if (e.data === 5) {
      //unstarted
      // console.log('queued');
    }
  }

  $.vidRescale = function(videocode) {
    // console.log('video player is resized');
    if (window.rdo.data.selected && window.rdo.data.selected.content.video && window.rdo.loader.introdone) {
      // console.log('playing at theatre');
      console.log('fit rate:' + window.rdo.video.fit);
      console.log('playing at:' + window.rdo.video.currenttv);

      if ($('.theatre.video').length) {
        // console.log('fit rate:' + window.rdo.video.fit);
        let w = $('.theatre.video').width(),
          h = $('.theatre.video').height(),
          r = window.rdo.video.fit,
          newWidth = 0,
          newHeight = 0,
          leftIndent = 0,
          topIndent = 0;

        if (w / h >= 16 / 9) {
          console.log(' 16:9');
          newWidth = w * r;
          newHeight = newWidth / 16 * 9;
          leftIndent = (newWidth - w) / -2;
          // topIndent = (newHeight - h) / -4;
          topIndent = 0;

          window.rdo.video.tv.setSize(newWidth, newHeight);
          $('.tv .screen').css({
            'left': leftIndent + 'px'
            // 'top': topIndent + 'px'
          });
        } else {
          console.log('not 16:9');
          newHeight = h * r;
          newWidth = newHeight / 9 * 16;
          leftIndent = (newWidth - w) / -2;
          // topIndent = (newHeight - h) / -4;
          topIndent = 0;

          window.rdo.video.tv.setSize(newWidth, newHeight);

          $('.tv .screen').css({
            'left': leftIndent + 'px'
            // 'top': topIndent + 'px'
          });
        }

        // console.log('page width: ' + w);
        // console.log('page height: ' + h);
        // console.log('newWidth: ' + newWidth);
        // console.log('leftIndent: ' + leftIndent);
        // console.log('newHeight: ' + newHeight);
        // console.log('topIndent: ' + topIndent);
      }

    } else if (window.rdo.video.tv) {
      if ($('.tv .screen').length) {
        // console.log('fit rate:' + window.rdo.video.fit);
        let w = $(document).width(),
          h = $(document).height(),
          r = window.rdo.video.fit,
          newWidth = 0,
          newHeight = 0,
          leftIndent = 0,
          topIndent = 0;

        if (w / h >= 16 / 9) {
          // console.log(' 16:9');
          newWidth = w * r;
          newHeight = newWidth / 16 * 9;
          leftIndent = (newWidth - w) / -2;
          // topIndent = (newHeight - h) / -4;
          topIndent = 0;

          window.rdo.video.tv.setSize(newWidth, newHeight);
          $('.tv .screen').css({
            'left': leftIndent + 'px'
            // 'top': topIndent + 'px'
          });
        } else {
          console.log('not 16:9');
          newHeight = h * r;
          newWidth = newHeight / 9 * 16;
          leftIndent = (newWidth - w) / -2;
          // topIndent = (newHeight - h) / -4;
          topIndent = 0;

          window.rdo.video.tv.setSize(newWidth, newHeight);

          $('.tv .screen').css({
            'left': leftIndent + 'px'
            // 'top': topIndent + 'px'
          });
        }

        // console.log('page width: ' + w);
        // console.log('page height: ' + h);
        // console.log('newWidth: ' + newWidth);
        // console.log('leftIndent: ' + leftIndent);
        // console.log('newHeight: ' + newHeight);
        // console.log('topIndent: ' + topIndent);
      }

    }

  }

  // $(window).on('resize', function() {
  //   $.vidRescale();
  // });

  window.onYouTubePlayerAPIReady = function() {
    // console.log('video player is ready');
    window.rdo.video.ready = true;
    // $.vidRescale();
  }

  $.playVideo = function(video, onDone, onPlay, onPause, onUnstarted) {
    // if (window.rdo.video.ready) {

    if (video) {
      window.rdo.video.numPlayAttempts = 0;
      $.pauseTimer();

      // console.log('video is created at tv');

      window.rdo.video.tv = new YT.Player(window.rdo.video.currenttv, {
        videoId: video,
        events: {
          'onReady': (e) => $.onPlayerReady(e),
          'onStateChange': (e) => $.onPlayerStateChange(e, onDone, onPlay, onPause, onUnstarted)
        },
        playerVars: window.rdo.video.playerDefaults
      });
      $.vidRescale();
      // console.log('tv is :' + window.rdo.video.tv);
      $('#full-page-background .overlay').addClass('video');
      $('#content-display .theatre').addClass('video');

      if (window.rdo.isMobile) {
        $('intro .tv iframe').hide();
      }

    } else {
      window.rdo.video.tv = null;
    }
    // } else {
    //   console.log('wait a sec!');
    //   setTimeout(function() {
    //     $.playVideo(video, onDone, onPlay, onPause);
    //   }, 1000);
    // }

  }
  $.cleanVideo = function() {
    $('#full-page-background .overlay').removeClass('video');
    $('#content-display .theatre').removeClass('video');
    window.rdo.video.tv = null;
  }

  $(function() {
    'use strict';
    //confi
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/player_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  });

  // $(window).on('load resize', function() {
  //   vidRescale();
  // });

  // $('.hi span:first-of-type').on('click touchstart', function() {
  //   $('#tv').toggleClass('mute');
  //   $('.hi em:first-of-type').toggleClass('hidden');
  //   if ($('#tv').hasClass('mute')) {
  //     tv.mute();
  //   } else {
  //     tv.unMute();
  //   }
  // });
  //
  // $('.hi span:last-of-type').on('click touchstart', function() {
  //   $('.hi em:nth-of-type(2)').html('~');
  //   tv.pauseVideo();
  // });
})(jQuery, this);
